var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:{'is-large': _vm.large}},[_c('div',{staticClass:"logo-icon"}),_c('div',{staticClass:"logo-text"},[_vm._v("geek"),_c('span',[_vm._v("group")]),(_vm.byline)?_c('div',{staticClass:"logo-byline"},[_vm._v("rocket "),_c('span',[_vm._v("fuel")]),_vm._v(" for bgg collections")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }